export default __webpack_public_path__ + "static/TSD_Header_1_featured-f04117125c0475a0711fd6eb6f26dccc.jpg";